import React, { useEffect, useState } from 'react';
import { Card, Form, Button, Row, Col, DatePicker, Spin, Table, Empty } from 'antd';
import { wtApiCall } from 'src/helpers/commons/ApiWrapper';
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications';
import './style.css'
import WidgetDatePicker from 'src/widgets/DatePickers/WidgetDatePicker';
const HrReport = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const [attendanceData, setAttendanceData] = useState([]);
  const [Training, setTraining] = useState([]);
  const [EmployeeReignThisMonth, setEmployeeReignThisMonth] = useState([]);
  const [EmployeeJoiningThisMonth, setEmployeeJoiningThisMonth] = useState([]);


  const [Date, setDate] = useState('')

  const [dateRange, setDateRange] = useState([]);

  const getReportData = () => {
    setIsLoading(true);
    wtApiCall(
      'reports/hr_report',
      {
        from_date: Date,
      },
      'get',
      (response) => {
        setAttendanceData(response.branches);
        setTraining(response.trainings);
        setEmployeeJoiningThisMonth(response.EmployeeJoiningThisMonth);
        setEmployeeReignThisMonth(response.EmployeeResignThisMonth);



        setIsLoading(false);
      },
      (error) => {
        lzNotifyErrorMessageFromResult(error);
        setIsLoading(false);
      },
    );
  };

  const columns = [
    {
      title: 'Ser.',
      dataIndex: 'serial',
      key: 'serial',
      width: '5%',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Branch',
      dataIndex: 'branch_name',
      key: 'branch',
      width: '20%',
    },
    {
      title: 'Present',
      dataIndex: 'officers',
      key: 'officer_presents',
      render: (officers) => officers.presents, // 
      width: '15%',
    },
    {
      title: 'Absent',
      dataIndex: 'officers',
      key: 'officer_absents',
      render: (officers) => officers.absents, // 
      width: '15%',
    },
    {
      title: 'Leave',
      dataIndex: 'officers',
      key: 'officers_leaves',
      render: (officers) => officers.leaves, // 
      width: '15%',
    },
    {
      title: 'On Move',
      dataIndex: 'officers',
      key: 'officers_on_move',
      render: (officers) => officers.on_move, // 
      width: '15%',
    },
    {
      title: 'Unpresented',
      dataIndex: 'officers',
      key: 'officers_unpresented',
      render: (officers) => officers.unpresented, // 
      width: '15%',
    },
  ];

  const columns2 = [
    {
      title: 'Ser.',
      dataIndex: 'serial',
      key: 'serial',
      width: '5%',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Branch',
      dataIndex: 'branch_name',
      key: 'branch',
      width: '20%',
    },
    {
      title: 'Present',
      dataIndex: 'staff',
      key: 'staff_presents',
      render: (staff) => staff.presents, // 
      width: '15%',
    },
    {
      title: 'Absent',
      dataIndex: 'staff',
      key: 'staffs_absents',
      render: (staff) => staff.absents, // 
      width: '15%',
    },
    {
      title: 'Leave',
      dataIndex: 'staff',
      key: 'staff_leaves',
      render: (staff) => staff.leaves, // 
      width: '15%',
    },
    {
      title: 'On Move',
      dataIndex: 'staff',
      key: 'staff_on_move',
      render: (staff) => staff.on_move, // 
      width: '15%',
    },
    {
      title: 'Unpresented',
      dataIndex: 'staff',
      key: 'staff_unpresented',
      render: (staff) => staff.unpresented, // 
      width: '15%',
    },
  ];
  const columns3 = [
    {
      title: 'Ser.',
      dataIndex: 'serial',
      key: 'serial',
      width: '5%',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Branch',
      dataIndex: 'branch_name',
      key: 'branch',
      width: '20%',
    },
    {
      title: 'HR Strength',
      dataIndex: 'leaves',
      key: 'hr_strenght',
      render: (leaves) => leaves.hr_strenght, // 
      width: '15%',
    },
    {
      title: 'Total Leaves availed last Month',
      dataIndex: 'leaves',
      key: 'employee_leave_last_month',
      render: (leaves) => leaves.employee_leave_last_month, // 
      width: '15%',
    },
    {
      title: 'Total Leaves availed This Month',
      dataIndex: 'leaves',
      key: 'employee_leave_this_month',
      render: (leaves) => leaves.employee_leave_this_month, // 
      width: '15%',
    },
    {
      title: 'Ratio',
      dataIndex: 'officers',
      key: 'staff_leaves',
      render: (staff) => staff.leaves, // 
      width: '15%',
    },

  ];
  const columns4 = [
    {
      title: 'Ser.',
      dataIndex: 'serial',
      key: 'serial',
      width: '5%',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Department',
      dataIndex: 'department_name',
      key: 'department_name',
      width: '20%',
    },
    {
      title: 'Cource Name',
      dataIndex: 'category_name',
      key: 'category_name',
      width: '20%',
    },
    {
      title: 'No Of Employees',
      dataIndex: 'training_count',
      key: 'training_count',
      width: '20%',
    },


  ];

  const columns5 = [
    {
      title: 'Ser.',
      dataIndex: 'serial',
      key: 'serial',
      width: '5%',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Department',
      dataIndex: 'department_name',
      key: 'department_name',
      width: '20%',
    },
    {
      title: 'No Of Employees',
      dataIndex: 'employee_count',
      key: 'employee_count',
      width: '20%',
    },
  ];

  const columns6 = [
    {
      title: 'Ser.',
      dataIndex: 'serial',
      key: 'serial',
      width: '5%',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Department',
      dataIndex: 'department_name',
      key: 'department_name',
      width: '20%',
    },
    {
      title: 'No Of Employees',
      dataIndex: 'employee_count',
      key: 'employee_count',
      width: '20%',
    },
  ];
  return (
    <div
      className="container-fluid"
      style={{
        padding: "1em",
        backgroundColor: "white",
        minHeight: "100vh",
        fontFamily: "Helvetica",
      }}
    >
      <Form
        layout={'vertical'}
        form={form}
        onFinish={getReportData}
        style={{ maxWidth: "100%", margin: '0 auto' }}
      >
        <Card
          style={{ width: "100%" }}
          title={<span style={{ fontSize: '26px', marginLeft: "45%" }}>HR Report</span>}
        >
          <Row gutter={[24, 24]}>
            <Col xs={15} sm={10} md={5}>
              <label>Date</label>
              <WidgetDatePicker
                value={Date}
                setDate={setDate}
                placeholder="Select From Date"
              />

            </Col>
            <Col xs={12} sm={8} md={5}>
              <Button
                style={{ marginTop: 30, marginRight: 5 }}
                type="primary"
                htmlType="submit"
                disabled={isLoading}
              >
                Search
              </Button>
            </Col>
          </Row>
        </Card>
      </Form>
      <Card style={{ marginTop: 30 }}>
        <Spin spinning={isLoading}>
          {attendanceData.length > 0 ? (
            <Table
              columns={columns}
              dataSource={attendanceData}
              rowKey="id"
              pagination={false}
              bordered
              title={() => (
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "16px",
                    padding: "0px",
                  }}
                >
                  Daily Attendance Report Officers - SUMMARY
                </div>
              )}
              rowClassName={() => "custom-row-padding"} // Add custom class for row padding
            />
          ) : (
            <Empty description="No Record Available!." />
          )}
        </Spin>
      </Card>

      <Card style={{ marginTop: 30 }}>
        <Spin spinning={isLoading}>
          {attendanceData.length > 0 ? (
            <Table
              columns={columns2}
              dataSource={attendanceData}
              rowKey="id"
              pagination={false}
              bordered
              title={() => (
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "16px",
                    padding: "0px",
                  }}
                >
                  Daily Attendance Report Staff - SUMMARY
                </div>
              )}
              rowClassName={() => "custom-row-padding"} // Add custom class for row padding
            />
          ) : (
            <Empty description="No Record Available!." />
          )}
        </Spin>
      </Card>

      <Card style={{ marginTop: 30 }}>
        <Spin spinning={isLoading}>
          {attendanceData.length > 0 ? (
            <Table
              columns={columns3}
              dataSource={attendanceData}
              rowKey="id"
              pagination={false}
              bordered
              title={() => (
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "16px",
                    padding: "0px",
                  }}
                >
                  Monthly Leaves Report - SUMMARY
                </div>
              )}
              rowClassName={() => "custom-row-padding"} // Add custom class for row padding
            />
          ) : (
            <Empty description="No Record Available!." />
          )}
        </Spin>
      </Card>

      <Card style={{ marginTop: 30 }}>
        <Spin spinning={isLoading}>
          {attendanceData.length > 0 ? (
            <Table
              columns={columns4}
              dataSource={Training}
              rowKey="id"
              pagination={false}
              bordered
              title={() => (
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "16px",
                    padding: "0px",
                  }}
                >
                  Training & Development Report - SUMMARY
                </div>
              )}
              rowClassName={() => "custom-row-padding"} // Add custom class for row padding
            />
          ) : (
            <Empty description="No Record Available!." />
          )}
        </Spin>
      </Card>

      <Card style={{ marginTop: 30 }}>
        <Spin spinning={isLoading}>
          {attendanceData.length > 0 ? (
            <Table
              columns={columns5}
              dataSource={EmployeeJoiningThisMonth}
              rowKey="id"
              pagination={false}
              bordered
              title={() => (
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "16px",
                    padding: "0px",
                  }}
                >
                  Appointments/Recruitment Report - SUMMARY

                </div>
              )}
              rowClassName={() => "custom-row-padding"} // Add custom class for row padding
            />
          ) : (
            <Empty description="No Record Available!." />
          )}
        </Spin>
      </Card>


      <Card style={{ marginTop: 30 }}>
        <Spin spinning={isLoading}>
          {attendanceData.length > 0 ? (
            <Table
              columns={columns6}
              dataSource={EmployeeReignThisMonth}
              rowKey="id"
              pagination={false}
              bordered
              title={() => (
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "16px",
                    padding: "0px",
                  }}
                >
                  Employee Retirement Report

                </div>
              )}
              rowClassName={() => "custom-row-padding"} // Add custom class for row padding
            />
          ) : (
            <Empty description="No Record Available!." />
          )}
        </Spin>
      </Card>
    </div>
  );
};

export default HrReport;
